// extracted by mini-css-extract-plugin
export default {"container":"styles_container__070TT","dateStyle":"styles_dateStyle__UK2Mp"};